// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-projects_Shared_shared_module_ts":"4f3f65c947a58ba9","projects_package-portal-ext_src_app_app_module_ts":"c5964a2cb1b770e7","projects_package-portal_src_app_app_module_ts":"7270c7c0ba9386fc"}[chunkId] + ".js";
};